import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62689920&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62689920",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\english\\new-evaluation\\src\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62689920')) {
      api.createRecord('62689920', component.options)
    } else {
      api.reload('62689920', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62689920&scoped=true&", function () {
      api.rerender('62689920', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/grade/index.vue"
export default component.exports